"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsTableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var SearchResultsTableRow = /** @class */ (function (_super) {
    __extends(SearchResultsTableRow, _super);
    function SearchResultsTableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.logAgentActivity = _this.logAgentActivity.bind(_this);
        return _this;
    }
    SearchResultsTableRow.prototype.render = function () {
        var customer = this.props.customer;
        return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.logAgentActivity, href: "/customers/".concat(customer.referenceNumber), target: "_blank", className: "text-decoration-none d-block px-3 py-3", children: customer.firstName }) }), (0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.logAgentActivity, href: "/customers/".concat(customer.referenceNumber), target: "_blank", className: "text-decoration-none d-block px-3 py-3", children: customer.lastName }) }), (0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.logAgentActivity, href: "/customers/".concat(customer.referenceNumber), target: "_blank", className: "text-decoration-none d-block px-3 py-3", children: moment(customer.dateOfBirth).format("DD/MM/YYYY") }) }), (0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.logAgentActivity, href: "/customers/".concat(customer.referenceNumber), target: "_blank", className: "text-decoration-none d-block px-3 py-3", children: customer.email }) }), (0, jsx_runtime_1.jsx)("td", { className: "p-0", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.logAgentActivity, href: "/customers/".concat(customer.referenceNumber), target: "_blank", className: "text-decoration-none d-block px-3 py-3", children: customer.postalCode }) })] }));
    };
    SearchResultsTableRow.prototype.logAgentActivity = function () {
        this.props.logAgentActivity(this.props.customer.referenceNumber);
    };
    SearchResultsTableRow = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], SearchResultsTableRow);
    return SearchResultsTableRow;
}(React.Component));
exports.SearchResultsTableRow = SearchResultsTableRow;
//# sourceMappingURL=SearchResultsTableRow.js.map